<template>
    <div class="msp-recupera-dati-strava">
        <v-alert dismissible type="info" :value="loading">
            <v-progress-circular
                size="20"
                indeterminate
                color="primary"
            ></v-progress-circular>
            Elaborazione in corso...
        </v-alert>


                <v-alert dismissible :type="message.type" :value="!!message.text">
                    {{message.text}}
                    </v-alert>
                        <template v-if="!loading">


                            <div class='msp-recupera-dati-strava__edit'>
                                <v-dialog
                                    ref="dialogData"
                                    v-model="editing"
                                    :return-value.sync="data"
                                    persistent
                                    width="290px"
                                >
                                    <v-date-picker
                                        v-model="data"
                                        scrollable
                                        :first-day-of-week="1"
                                        locale="it-it"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="editing = false"
                                        >
                                            Annulla
                                        </v-btn>
                                        <v-btn
                                            color="primary"
                                            @click="$refs.dialogData.save(data); recuperaDatiStrava()"
                                        >
                                            Recupera Dati
                                        </v-btn>
                                    </v-date-picker>
                                </v-dialog>
                                <v-btn 
                                    @click="editing = true"
                                >
                                <i class="msp-icon-download" />&nbsp;Recupera allenamenti
                                </v-btn>
                            </div>

</template>
</div>

</template>

<script>
import api from "../../../js/msp/api.js";
import CONFIG from "../../../js/msp/config.js";
const component = {
    props: [
        "atletaId"
    ],
    data() {
        return {
            editing: false,
            message: {
                'type': null,
                'text': null,
            },
            loading: false,
            data: null,
        }
    },
    methods: {
        setSuccess: function (text) {
            this.message = {
                type: 'success',
                text: text,
            };
        },
        setError: function (text) {
            this.message = {
                type: 'error',
                text: text,
            };
        },
        startLoading: function () {
            this.loading = true;
            this.editing = false;
            this.resetMessage();
        },
        resetMessage: function () {
            this.message = {
                type: null,
                text: null,
            };
        },
        stopLoading: function () {
            this.loading = false;
            this.editing = false;
            this.data = null;
        },
        recuperaDatiStrava: function () {
            if (!this.atletaId) {
                return;
            }
            const atletaId = this.atletaId;
            const data = this.data;
            return new Promise((resolve, reject)=>{
                this.startLoading();
                api.get(`recupera_dati_strava.php?data=${data}&atleta_id=${atletaId}`, CONFIG.api_base_url+"/api/v2")
                    .then((result)=>{
                        this.stopLoading();
                        if (result.success) {
                            this.setSuccess("Allenamento recuperato.");
                        } else if (result.message && result.message.text === 'STRAVA_NO_RESULTS') {
                            this.setSuccess("Nessun allenamento da recuperare.");
                        } else {
                            this.setError("Ops... Qualcosa non va. Segnalalo a CoachPeaking.");
                        }
                        resolve(result);
                    })
                    .catch((error) => {
                        this.stopLoading();
                        this.setError("Ops... Qualcosa non va. Segnalalo a CoachPeaking.");
                        reject(error);
                    });
            });
        },
    }
}
export default component;
</script>
